export default __webpack_public_path__ + "assets/13251504d997c74bb5197b165e7dcce9.svg";